<template>
  <div id="tab-ams" class="ams-info">
    <!--ENS按钮：数据抄录/同步HBL信息/代码检索...-->
    <div v-if="showCodeSearch" class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div>
          <el-dropdown
            style="padding-left: 5px;"
            :class="readonly?'not-click':''"
            split-button
            type="primary"
            no="1"
            @click="commandHandle(command1)"
            @command="p=>{command1=p;commandHandle(command1);}"
          >
            {{ this.getItemTitle(command1) }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="Copy Last Time" :title="$t('SeaExport.CopyLast')">{{ this.getItemTitle('Copy Last Time') }}</el-dropdown-item>
              <el-dropdown-item command="Copy By File NO" :title="$t('SeaExport.WaybillNumberCopy')">{{ this.getItemTitle('Copy By File NO') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <!--收发通信息/货物信息/运输信息/其他信息-->
    <div style="width: fit-content">
      <div style="display: flex" class="address-format-from">
        <!--其他信息-->
        <div class="section form-column" style="width: 400px;">
          <el-form :disabled="readonly" label-width="110px" label-position="left" style="height:100%">
            <span class="title" :title="$t('SeaExport.OtherInformation')">{{ getItemTitle('Other') }}</span>
            <el-form-item label-width="0" class="auto-width">
              <cargo-ag-grid
                :grid-options="ams2.gridOptions"
                :column-defs="ams2ColumnDefs"
                :row-data="ams2.rowData"
                style="width:100%;height:200px"
                @gridReady="params=>{ams2.gridApi=params.api}"
              />
              <div style="padding:5px 0">
                <div style="float:right">
                  <el-button type="primary" :title="$t('SeaExport.SynchronizeHBLInformation')" no="2" @click="pm.btnSynchroClickHandler()">{{ getItemTitle('Synchronise HB/L') }}</el-button>
                  <el-button type="danger" :title="$t('SeaExport.Delete')" no="4" @click="pm.onRemoveCargoDoc()">{{ getItemTitle('Delete') }}</el-button>
                </div>
              </div>
            </el-form-item>
            <span class="title" :title="'ENS '+$t('SeaExport.DeclarationInformation')">{{ getItemTitle('ENS Declaration Information') }}</span>
            <el-form-item class="blue-text" :label="getItemTitle('ENS Declaration Type')">
              <el-select v-model="form.declarationType" :disabled="readonly || isTradetech" no="5">
                <el-option label="F14" value="F14" />
                <el-option label="F15" value="F15" />
                <el-option label="F16" value="F16" />
                <el-option label="F17" value="F17" />
              </el-select>
            </el-form-item>
            <el-form-item v-show="isShow(true,true,false)" :class="isDifferent(true,true,false)" :label="getItemTitle('Carrier EORI')" :title="$t('SeaExport.ShippingCompanyEORI')">
              <cargo-advance-select
                :cache="false"
                :allow-create="true"
                filterable
                tag-name="code"
                tag-value="code"
                :default-value="form.carrierEori"
                :static-options="localData.carrierEoriList"
                no="6"
                @parentCallBack="p=>{form.carrierEori = p.value}"
              />
            </el-form-item>
            <el-form-item v-show="isShow(false,true,true)" class="blue-text" :label="getItemTitle('Declarant EORI')" :title="$t('SeaExport.DeclarantEORI')">
              <cargo-advance-select
                :cache="false"
                :allow-create="true"
                filterable
                tag-name="code"
                tag-value="code"
                :default-value="form.declarantEori"
                :static-options="localData.declarantEoriList"
                no="7"
                @parentCallBack="p=>{form.declarantEori = p.value}"
              />
            </el-form-item>
            <el-form-item v-show="isShow(true,true,false)" :label="getItemTitle('Memberstate')" :class="isDifferent(true, true, false)" :title="$t('SeaExport.Memberstate')">
              <cargo-advance-select
                no="8"
                :static-options="declaringCountrys"
                :cache="false"
                :default-value="form.declaringMemberCountry"
                filterable
                clearable
                :filter-tag-names="['code']"
                tag-name="code"
                tag-value="code"
                @parentCallBack="p=>{form.declaringMemberCountry = p.value}"
              />
            </el-form-item>
            <!--<el-form-item v-show="isYitong" class="blue-text" label-width="150px" :label="getItemTitle('Quantity of HBL>1')">
              <el-select v-model="form.multipleHbl" no="9">
                <el-option label="Y" :value="true" />
                <el-option label="N" :value="false" />
              </el-select>
            </el-form-item>-->
            <el-form-item v-show="isShow(true, false, true)" :class="isDifferent(true, false, true)" :title="$t('SeaExport.FLCLType')" :label="getItemTitle('Consignment Type')">
              <el-select
                v-model="form.containerLoadType"
                :placeholder="$t('SeaExport.PleaseChoose')"
                no="10"
              >
                <el-option
                  v-for="(item,index) in consignmentTypes"
                  :key="index"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-show="!(isYitong && isF16F17)" :label="getItemTitle('Cargo Type')" :title="$t('SeaExport.CargoType')">
              <el-select v-model="form.goodsType" no="11">
                <el-option :label="getItemTitle('General Cargo')" :value="0" />
                <el-option :label="getItemTitle('Dangerous Cargo')" :value="1" />
                <el-option :label="getItemTitle('Chemical Cargo')" :value="2" />
              </el-select>
            </el-form-item>
            <!-- 新增申报类型 -->
            <div v-show="!((isF16F17 || isF14) && isYitong)">
              <span :title="$t('SeaExport.DeclarationType')" class="blue-text">{{ getItemTitle('Declare Type') }}</span>
              <el-form-item label-width="0" style="margin-top: 5px">
                <el-radio-group v-model="form.frob" no="12">
                  <el-tooltip effect="dark" placement="right" style="display: block">
                    <el-radio :disabled="readonly" label="I" value="I">Import</el-radio>
                  </el-tooltip>
                  <el-tooltip effect="dark" placement="right" style="display: block">
                    <el-radio :disabled="readonly" label="F" value="F">Freight Remain on Board</el-radio>
                  </el-tooltip>
                </el-radio-group>
              </el-form-item>
            </div>
            <div v-show="!(isYitong && isF16F17)">
              <span :title="$t('SeaExport.ChargesPaymentMethod')" class="blue-text">{{ getItemTitle('Charges Payment Method') }}</span>
              <el-form-item label-width="0" style="margin-top: 5px">
                <el-radio-group v-model="form.chargesPaymentMethod" class="blue-text" no="13">
                  <el-tooltip effect="dark" placement="right" style="display: block">
                    <el-radio :disabled="readonly" label="A" value="A">Payment in cash</el-radio>
                  </el-tooltip>
                  <el-tooltip effect="dark" placement="right" style="display: block">
                    <el-radio :disabled="readonly" label="B" value="B">Payment by credit card</el-radio>
                  </el-tooltip>
                  <el-tooltip effect="dark" placement="right" style="display: block">
                    <el-radio :disabled="readonly" label="C" value="C">Payment by cheque</el-radio>
                  </el-tooltip>
                  <el-tooltip effect="dark" placement="right" style="display: block">
                    <el-radio :disabled="readonly" label="D" value="D">Other</el-radio>
                  </el-tooltip>
                  <el-tooltip effect="dark" placement="right" style="display: block">
                    <el-radio :disabled="readonly" label="H" value="H">Electronic credit transfer</el-radio>
                  </el-tooltip>
                  <el-tooltip effect="dark" placement="right" style="display: block">
                    <el-radio :disabled="readonly" label="Y" value="Y">Account holder with carrier</el-radio>
                  </el-tooltip>
                  <el-tooltip effect="dark" placement="right" style="display: block">
                    <el-radio :disabled="readonly" label="Z" value="Z">Not pre-paid</el-radio>
                  </el-tooltip>
                  <el-tooltip v-if="isTradetech" effect="dark" placement="right" style="display: block">
                    <el-radio :disabled="readonly" label="Wire" value="Wire">Wire</el-radio>
                  </el-tooltip>
                  <el-tooltip v-if="isTradetech" effect="dark" placement="right" style="display: block">
                    <el-radio :disabled="readonly" label="ACH" value="ACH">ACH</el-radio>
                  </el-tooltip>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <!--收发通信息-->
        <ens-address-format-form
          v-show="!((isYitong || isEFreight) && isF16F17)"
          style="width: 400px;height: 1350px"
          :job="job"
          :show-second-notify-party="showSecondNotifyParty"
          :readonly="readonly"
          :local-data="localData"
          :address-form="form.afrAddress[0] || {}"
          :tab-name="tabName"
          :declaration-type="form.declarationType"
          @showSenderAndReceiverDialog="showSenderAndReceiverDialog"
          @selectionItemHandlerByType="p=>{pm.selectionItemHandlerByType(p)}"
        />
        <!--买卖方信息-->
        <div v-show="!isF14" class="section form-column" style="width: 400px;">
          <span class="title" :title="$t('SeaExport.BuyerAndSellerInformation')">{{ getItemTitle('Buyer and Seller Information') }}</span>
          <el-form :disabled="readonly" label-position="right" label-width="110px" style="height:100%">
            <!--卖方信息-->
            <el-form-item :label="getItemTitle('Seller')">
              <el-button
                :disabled="readonly"
                no="14"
                type="primary"
                style="vertical-align: top"
                @click="copyAddress('Seller')"
              >{{ $t('SeaExport.CopyConsignor') }}
              </el-button>
            </el-form-item>
            <el-form-item :title="$t('SeaExport.Name')">
              <span slot="label" :class="form.frob === 'I' ? isDifferent(true, true, true) : ''">{{ getItemTitle('Name') }}</span>
              <cargo-rich-textarea
                v-model="addressForm.sellerName"
                :disabled="readonly"
                :text-chars="0"
                :warning-count="40"
                :is-trim="true"
                style="min-height: unset;"
                no="15"
                @dblclick.native="showSenderAndReceiverDialog('seller',3)"
              />
            </el-form-item>
            <el-form-item :title="$t('SeaExport.Addr') + '1'">
              <span slot="label" :class="form.frob === 'I' ? isDifferent(true, true, true) : ''">{{ getItemTitle('Address') + '1' }}</span>
              <cargo-rich-textarea
                v-model="addressForm.sellerAddress1"
                :disabled="readonly"
                :text-chars="0"
                :warning-count="40"
                :is-trim="true"
                style="min-height: unset;"
                no="16"
                @dblclick.native="showSenderAndReceiverDialog('seller',3)"
              />
            </el-form-item>
            <el-form-item :label="getItemTitle('Address') + '2'" :title="$t('SeaExport.Addr') + '2'">
              <span slot="label">{{ getItemTitle('Address') + '2' }}</span>
              <cargo-rich-textarea
                v-model="addressForm.sellerAddress2"
                :disabled="readonly"
                :text-chars="0"
                :warning-count="40"
                :is-trim="true"
                style="min-height: unset;"
                no="17"
                @dblclick.native="showSenderAndReceiverDialog('seller',3)"
              />
            </el-form-item>
            <el-form-item v-show="!isTradetech" :label="getItemTitle('Street No')" :class="form.frob === 'I' ? isDifferent(true, true, true) : ''">
              <el-input v-model="addressForm.sellerStreetNo" no="18" />
            </el-form-item>
            <el-form-item :label="getItemTitle('Country')" :title="$t('SeaExport.Country')" :class="form.frob === 'I' ? isDifferent(false, false, true) : ''">
              <div style="display: flex">
                <cargo-advance-select
                  no="19"
                  :select-type="TYPE_NAMES.basic_data_Country"
                  :cache="false"
                  filterable
                  :default-value="addressForm.sellerCountry"
                  :filter-tag-names="['code','chineseName','name']"
                  tag-name="code"
                  tag-value="code"
                  @parentCallBack="p=>{addressForm.sellerCountry = p.value}"
                />
                <span :class="form.frob === 'I' ? isDifferent(true, true, true) : ''" style="margin-left: 5px;margin-right: 5px;width: 110px;" :title="$t('SeaExport.City')">{{ getItemTitle('City') }}</span>
                <el-input v-model="addressForm.sellerCity" :class="cityMaxLength(addressForm.sellerCity)" no="20" />
              </div>
            </el-form-item>
            <el-form-item :label="getItemTitle('ZIP')" :title="$t('SeaExport.ZIP')" :class="form.frob === 'I' ? isDifferent(false, true, false) : ''">
              <div style="display: flex">
                <el-input v-model="addressForm.sellerPostalcode" :class="zipMaxLength(addressForm.sellerPostalcode)" no="21" />
                <span style="margin-left: 5px;margin-right: 5px;width: 110px;" :title="$t('SeaExport.Province')">{{ getItemTitle('State') }}</span>
                <el-input v-model="addressForm.sellerProvince" :class="stateMaxLength(addressForm.sellerProvince)" no="22" />
              </div>
            </el-form-item>
            <el-form-item :label="getItemTitle('Email')" :title="$t('SeaExport.Email')" :class="form.frob === 'I' ? isDifferent(false, false, true) : ''">
              <div style="display: flex">
                <el-input v-model="addressForm.sellerEmail" :class="emailMaxLength(addressForm.sellerEmail)" no="23" />
                <span style="margin-left: 5px;margin-right: 5px;width: 110px;" :title="$t('SeaExport.Tel')" :class="form.frob === 'I' ? isDifferent(false, false, true) : ''">{{ getItemTitle('Tel') }}</span>
                <el-input v-model="addressForm.sellerTel" :class="telMaxLength(addressForm.sellerTel)" :placeholder="!readonly&&isEFreight?$t('SeaExport.TelSeparate'):''" no="24" />
              </div>
            </el-form-item>
            <el-form-item v-show="!isYitong" :label="getItemTitle('Contact Name')">
              <cargo-rich-textarea
                v-model="addressForm.sellerContactName"
                :disabled="readonly"
                :text-chars="0"
                :warning-count="contactNameMaxLength"
                :is-trim="true"
                style="min-height: unset;"
                no="25"
              />
            </el-form-item>
            <el-form-item :label="getItemTitle('Type Of Person')">
              <el-select v-model="addressForm.sellerTypeOfPerson" no="26">
                <el-option :label="getItemTitle('NATURAL')" value="1" />
                <el-option :label="getItemTitle('LEGAL')" value="2" />
                <el-option :label="getItemTitle('ASSOCIATION')" value="3" />
              </el-select>
            </el-form-item>
            <el-form-item :label="getItemTitle('EORI')">
              <cargo-rich-textarea
                v-model="addressForm.sellerEori"
                :disabled="readonly"
                :text-chars="0"
                :warning-count="17"
                :is-trim="true"
                style="min-height: unset;"
                no="27"
              />
            </el-form-item>
            <!--买方信息-->
            <el-form-item :label="getItemTitle('Buyer')">
              <el-button
                :disabled="readonly"
                no="28"
                type="primary"
                style="vertical-align: top"
                @click="copyAddress('Buyer')"
              >{{ $t('SeaExport.CopConsignee') }}
              </el-button>
            </el-form-item>
            <el-form-item :title="$t('SeaExport.Name')">
              <span slot="label" :class="form.frob === 'I' ? isDifferent(true, true, true) : ''">{{ getItemTitle('Name') }}</span>
              <cargo-rich-textarea
                v-model="addressForm.buyerName"
                :disabled="readonly"
                :text-chars="0"
                :warning-count="40"
                :is-trim="true"
                style="min-height: unset;"
                no="29"
                @dblclick.native="showSenderAndReceiverDialog('buyer',2)"
              />
            </el-form-item>
            <el-form-item :title="$t('SeaExport.Addr') + '1'">
              <span slot="label" :class="form.frob === 'I' ? isDifferent(true, true, true) : ''">{{ getItemTitle('Address') + '1' }}</span>
              <cargo-rich-textarea
                v-model="addressForm.buyerAddress1"
                :disabled="readonly"
                :text-chars="0"
                :warning-count="40"
                :is-trim="true"
                style="min-height: unset;"
                no="30"
                @dblclick.native="showSenderAndReceiverDialog('buyer',2)"
              />
            </el-form-item>
            <el-form-item :label="getItemTitle('Address') + '2'" :title="$t('SeaExport.Addr') + '2'">
              <span slot="label">{{ getItemTitle('Address') + '2' }}</span>
              <cargo-rich-textarea
                v-model="addressForm.buyerAddress2"
                :disabled="readonly"
                :text-chars="0"
                :warning-count="40"
                :is-trim="true"
                style="min-height: unset;"
                no="31"
                @dblclick.native="showSenderAndReceiverDialog('buyer',3)"
              />
            </el-form-item>
            <el-form-item v-show="!isTradetech" :label="getItemTitle('Street No')" :class="form.frob === 'I' ? isDifferent(true, true, true) : ''">
              <el-input v-model="addressForm.buyerStreetNo" no="32" />
            </el-form-item>
            <el-form-item :label="getItemTitle('Country')" :title="$t('SeaExport.Country')" :class="form.frob === 'I' ? isDifferent(false, false, true) : ''">
              <div style="display: flex">
                <cargo-advance-select
                  no="33"
                  :select-type="TYPE_NAMES.basic_data_Country"
                  :cache="false"
                  filterable
                  :default-value="addressForm.buyerCountry"
                  :filter-tag-names="['code','chineseName','name']"
                  tag-name="code"
                  tag-value="code"
                  @parentCallBack="p=>{addressForm.buyerCountry = p.value}"
                />
                <span :class="form.frob === 'I' ? isDifferent(true, true, true) : ''" style="margin-left: 5px;margin-right: 5px;width: 110px;" :title="$t('SeaExport.City')">{{ getItemTitle('City') }}</span>
                <el-input v-model="addressForm.buyerCity" :class="cityMaxLength(addressForm.buyerCity)" no="34" />
              </div>
            </el-form-item>
            <el-form-item :label="getItemTitle('ZIP')" :title="$t('SeaExport.ZIP')" :class="form.frob === 'I' ? isDifferent(false, true, false) : ''">
              <div style="display: flex">
                <el-input v-model="addressForm.buyerPostalcode" :class="zipMaxLength(addressForm.buyerPostalcode)" no="35" />
                <span style="margin-left: 5px;margin-right: 5px;width: 110px;" :title="$t('SeaExport.Province')">{{ getItemTitle('State') }}</span>
                <el-input v-model="addressForm.buyerProvince" no="36" :class="stateMaxLength(addressForm.buyerProvince)" />
              </div>
            </el-form-item>
            <el-form-item :label="getItemTitle('Email')" :title="$t('SeaExport.Email')" :class="form.frob === 'I' ? isDifferent(false, false, true) : ''">
              <div style="display: flex">
                <el-input v-model="addressForm.buyerEmail" :class="emailMaxLength(addressForm.buyerEmail)" no="37" />
                <span style="margin-left: 5px;margin-right: 5px;width: 110px;" :title="$t('SeaExport.Tel')" :class="form.frob === 'I' ? isDifferent(false, false, true) : ''">{{ getItemTitle('Tel') }}</span>
                <el-input v-model="addressForm.buyerTel" :class="telMaxLength(addressForm.buyerTel)" :placeholder="!readonly&&isEFreight?$t('SeaExport.TelSeparate'):''" no="38" />
              </div>
            </el-form-item>
            <el-form-item v-show="!isYitong" :label="getItemTitle('Contact Name')">
              <cargo-rich-textarea
                v-model="addressForm.buyerContactName"
                :disabled="readonly"
                :text-chars="0"
                :warning-count="contactNameMaxLength"
                :is-trim="true"
                style="min-height: unset;"
                no="39"
              />
            </el-form-item>
            <el-form-item :label="getItemTitle('Type Of Person')">
              <el-select v-model="addressForm.buyerTypeOfPerson" no="40">
                <el-option :label="getItemTitle('NATURAL')" value="1" />
                <el-option :label="getItemTitle('LEGAL')" value="2" />
                <el-option :label="getItemTitle('ASSOCIATION')" value="3" />
              </el-select>
            </el-form-item>
            <el-form-item :label="getItemTitle('EORI')">
              <cargo-rich-textarea
                v-model="addressForm.buyerEori"
                :disabled="readonly"
                :text-chars="0"
                :warning-count="17"
                :is-trim="true"
                style="min-height: unset;"
                no="41"
              />
            </el-form-item>
            <!--代表人-->
            <div v-show="isYitong">
              <el-form-item :label="getItemTitle('Representative')" />
              <el-form-item :label="getItemTitle('Name')" :title="$t('SeaExport.Name')">
                <el-input v-model="addressForm.representativeName" no="76" @dblclick.native="showSenderAndReceiverDialog('representative',2)" />
              </el-form-item>
              <el-form-item :label="getItemTitle('Address') + '1'" :title="$t('SeaExport.Addr') + '1'">
                <el-input v-model="addressForm.representativeAddress1" no="77" />
              </el-form-item>
              <el-form-item :label="getItemTitle('Address') + '2'" :title="$t('SeaExport.Addr') + '2'">
                <el-input v-model="addressForm.representativeAddress2" no="78" />
              </el-form-item>
              <el-form-item :label="getItemTitle('Street No')">
                <el-input v-model="addressForm.representativeStreetNo" no="79" />
              </el-form-item>
              <el-form-item :label="getItemTitle('Country')" :title="$t('SeaExport.Country')">
                <div style="display: flex">
                  <cargo-advance-select
                    no="88"
                    :select-type="TYPE_NAMES.basic_data_Country"
                    :cache="false"
                    filterable
                    :default-value="addressForm.representativeCountry"
                    :filter-tag-names="['code','chineseName','name']"
                    tag-name="code"
                    tag-value="code"
                    @parentCallBack="p=>{addressForm.representativeCountry = p.value}"
                  />
                  <span class="center-label" :title="$t('SeaExport.City')">{{ getItemTitle('City') }}</span>
                  <el-input v-model="addressForm.representativeCity" no="80" />
                </div>
              </el-form-item>
              <el-form-item :label="getItemTitle('ZIP')" :title="$t('SeaExport.ZIP')">
                <div style="display: flex">
                  <el-input v-model="addressForm.representativePostalcode" no="81" />
                  <span style="margin-left: 5px;margin-right: 5px;width: 110px;" :title="$t('SeaExport.Province')">{{ getItemTitle('State') }}</span>
                  <el-input v-model="addressForm.representativeProvince" no="82" />
                </div>
              </el-form-item>
              <el-form-item :label="getItemTitle('Email')" :title="$t('SeaExport.Email')">
                <div style="display: flex">
                  <el-input v-model="addressForm.representativeEmail" no="83" />
                  <span style="margin-left: 5px;margin-right: 5px;width: 110px;" :title="$t('SeaExport.Tel')">{{ getItemTitle('Tel') }}</span>
                  <el-input v-model="addressForm.representativeTel" :placeholder="!readonly&&isEFreight?$t('SeaExport.TelSeparate'):''" no="87" />
                </div>
              </el-form-item>
              <el-form-item v-if="isYitong" :label="getItemTitle('Representative type')">
                <el-select v-model="addressForm.representativeTypeOfPerson" no="85">
                  <el-option :label="$t('SeaExport.DirectlyRepresenting')" value="2" />
                  <el-option :label="$t('SeaExport.IndirectRepresentation')" value="3" />
                </el-select>
              </el-form-item>
              <el-form-item v-else :label="getItemTitle('Type Of Person')">
                <el-select v-model="addressForm.representativeTypeOfPerson" no="85">
                  <el-option :label="getItemTitle('NATURAL')" value="1" />
                  <el-option :label="getItemTitle('LEGAL')" value="2" />
                  <el-option :label="getItemTitle('ASSOCIATION')" value="3" />
                </el-select>
              </el-form-item>
              <el-form-item :label="getItemTitle('EORI')">
                <el-input v-model="addressForm.representativeEori" no="86" />
              </el-form-item>
            </div>
          </el-form>
          <div style="margin-bottom: 10px;" />
        </div>
        <!--运输信息-->
        <div v-show="!(isF16F17 && isYitong)" class="section form-column" style="width: 400px;">
          <el-form :disabled="readonly" label-width="120px" label-position="right" style="height:100%">
            <span class="title" :title="$t('SeaExport.TransportationInformation')">{{ getItemTitle('Shipping Information') }}</span>
            <el-form-item :title="$t('SeaExport.EnsNo')">
              <span slot="label" class="blue-text">ENS NO</span>
              <cargo-rich-textarea
                v-model="form.hblNbr2"
                :disabled="readonly"
                :text-chars="0"
                :warning-count="ensNoMaxLength"
                :is-trim="true"
                style="min-height: unset;"
                no="42"
                @blur="hblNbr2Change"
              />
            </el-form-item>
            <el-form-item :title="$t('SeaExport.MBLNumber')">
              <span slot="label" :class="isDifferent(true, true,true)">{{ getItemTitle('MB/L NO') }}</span>
              <cargo-rich-textarea
                v-model="form.mbl"
                :disabled="readonly"
                :text-chars="0"
                :warning-count="mblMaxLength"
                :is-trim="true"
                style="min-height: unset;"
                no="43"
              />
            </el-form-item>
            <div v-show="!(isF16F17 && isEFreight)">
              <el-form-item :class="isDifferent(true,false,false)" :label="getItemTitle('Vessel')" :title="$t('SeaExport.ShipName')">
                <cargo-advance-select
                  :select-type="TYPE_NAMES.static_data_Vessel"
                  :cache="false"
                  :allow-create="true"
                  filterable
                  :default-value="form.vessel"
                  :static-options="localData.vesselList"
                  no="44"
                  @parentCallBack="p=>{pm.onVesselSelectionChange(p)}"
                />
              </el-form-item>
              <el-form-item :title="$t('SeaExport.Voyage')">
                <template slot="label">
                  <span :class="isDifferent(true, false,false)">{{ getItemTitle('Voyage') }}</span>
                </template>
                <cargo-rich-textarea
                  v-model="form.voyageFlight"
                  :disabled="readonly"
                  :max-count="voyageMaxLength"
                  :is-trim="true"
                  style="min-height: unset;"
                  no="45"
                  @change="changeVoyage"
                  @blur="voyageFlightBlur"
                />
              </el-form-item>
              <el-form-item :label="getItemTitle('IMO')" :title="$t('SeaExport.ShipNumber')" :class="isDifferent(true, false,false)">
                <el-input v-model="form.vesselIMO" :maxlength="imoMaxLength" no="46" />
              </el-form-item>
            </div>
            <el-form-item :label="getItemTitle('ETD')" :title="$t('SeaExport.DateOfDeparture')" :class="isDifferent(true, false,false)">
              <el-date-picker v-model="form.etd" type="date" value-format="yyyy-MM-dd" style="width:100%;" no="47" />
            </el-form-item>
            <el-form-item :label="getItemTitle('ETA')" :title="$t('SeaExport.ArrivalDate')" :class="isDifferent(true, false,false)">
              <el-date-picker v-model="form.eta" type="date" value-format="yyyy-MM-dd" style="width:100%;" no="48" />
            </el-form-item>
            <el-form-item v-show="isTradetech" :label="getItemTitle('Deliv.Mode')">
              <cargo-advance-select
                no="freightTerm"
                filterable
                :default-value="form.freightTermHBL"
                :cache="false"
                tag-name="chineseName"
                tag-value="code"
                :filter-tag-names="['code','chineseName']"
                :static-options="SystemConstants.AMS_FREIGHT_TERM"
                @parentCallBack="p=>{form.freightTermHBL=p.value;}"
              />
            </el-form-item>
            <el-form-item v-show="isShow(true,false,true) && !(isF16F17 && isEFreight)" :label="getItemTitle('Place of Receipt')" :title="$t('SeaExport.BillLadingPlaceOfDispatch')" :class="isDifferent(true, false,false)">
              <cargo-advance-select
                :select-type="TYPE_NAMES.basic_data_Seaport"
                filterable
                :default-value="form.dispatchingPlaceCode"
                tag-name="englishName"
                style="flex:1"
                no="49"
                @parentCallBack="p=>{portChange(p, 'dispatchingPlaceCode', 'dispatchingPlace')}"
              />
              <el-input v-model="form.dispatchingPlace" />
            </el-form-item>
            <el-form-item :label="getItemTitle('Place of Loading')" :title="$t('SeaExport.BillLadingPortOfDeparture')" :class="isDifferent(true, true,true)">
              <cargo-advance-select
                :select-type="TYPE_NAMES.basic_data_Seaport"
                filterable
                :default-value="form.loadingPortCode||''"
                tag-name="englishName"
                no="50"
                @parentCallBack="p=>{portChange(p, 'loadingPortCode', 'loadingPort')}"
              />
              <el-input v-model="form.loadingPort" />
            </el-form-item>
            <el-form-item :label="getItemTitle('Place of Discharge')" :title="$t('SeaExport.BillLadingPortOfDischarge')" :class="isDifferent(true, true,true)">
              <cargo-advance-select
                :select-type="TYPE_NAMES.basic_data_Seaport"
                filterable
                :default-value="form.dischargingPortCode||''"
                tag-name="englishName"
                no="51"
                @parentCallBack="p=>{portChange(p, 'dischargingPortCode', 'dischargingPort')}"
              />
              <el-input v-model="form.dischargingPort" />
            </el-form-item>
            <div v-show="!(isF16F17 && isEFreight)">
              <el-form-item :label="getItemTitle('Place Of Delivery')" :title="$t('SeaExport.BillLadingPlaceOfDelivery')" :class="isDifferent(true, false,false)">
                <cargo-advance-select
                  :select-type="TYPE_NAMES.basic_data_Seaport"
                  filterable
                  :default-value="form.destinationPortCode||''"
                  tag-name="englishName"
                  no="52"
                  @parentCallBack="p=>{portChange(p, 'destinationPortCode', 'destinationPort')}"
                />
                <el-input v-model="form.destinationPort" />
              </el-form-item>
              <el-form-item v-show="isShow(false,false,true)" :label="getItemTitle('First Port of Call')" :title="$t('SeaExport.FirstPortOfCall')" :class="isDifferent(false, false,true)">
                <cargo-advance-select
                  filterable
                  :select-type="TYPE_NAMES.basic_data_Seaport"
                  :default-value="form.firstPortOfCallCode"
                  no="53"
                  @parentCallBack="p=>{portChange(p, 'firstPortOfCallCode', 'firstPortOfCall')}"
                />
                <el-input v-model="form.firstPortOfCall" />
              </el-form-item>
              <el-form-item v-show="isShow(false,false,true)" :label="getItemTitle('Last Foreign Port')" :title="$t('SeaExport.LastOverseasPort')">
                <cargo-advance-select
                  filterable
                  :select-type="TYPE_NAMES.basic_data_Seaport"
                  :default-value="form.lastAbroadProd"
                  no="54"
                  @parentCallBack="p=>{portChange(p, 'lastAbroadProd', 'lastAbroadProdName')}"
                />
                <el-input v-model="form.lastAbroadProdName" />
              </el-form-item>
              <div v-show="isShow(true,true,false)">
                <span :class="isDifferent(true, true,false)">{{ getItemTitle('RouteCountry') }}</span>
                <br>
                <br>
                <el-button :disabled="readonly" size="mini" type="primary" @click="addRouteCountry">{{ $t('SystemMaintenance.Add') }}</el-button>
                <el-button :disabled="readonly" size="mini" type="primary" @click="deleteRouteCountry">{{ $t('SystemMaintenance.Delete') }}</el-button>
                <cargo-ag-grid
                  :grid-options="routeCountry.gridOptions"
                  :column-defs="columnDefs"
                  :row-data="form.routeCountryList"
                  :show-side-bar="false"
                  style="width:100%;"
                  @gridReady="params=>{gridApi=params.api}"
                />
              </div>
            </div>
            <div v-show="isF14 || isTradetech">
              <br>
              <el-form-item v-show="isShow(true,false,false)" class="blue-text" :label="getItemTitle('ColoadInSelfFilingIndicator')">
                <el-select v-model="form.coloadInSelfFilingIndicator" no="55" style="width: 200px;float: right">
                  <el-option :label="$t('SeaExport.yes')" :value="true" />
                  <el-option :label="$t('SeaExport.no')" :value="false" />
                </el-select>
              </el-form-item>
              <br>
              <div v-show="form.coloadInSelfFilingIndicator || isTradetech || isYitong">
                <el-button :disabled="readonly" size="mini" type="primary" @click="addRouteCountry2">{{ $t('SystemMaintenance.Add') }}</el-button>
                <el-button :disabled="readonly" size="mini" type="primary" @click="deleteRouteCountry2">{{ $t('SystemMaintenance.Delete') }}</el-button>
                <cargo-ag-grid
                  :grid-options="coloadInSelfFilingIndicator.gridOptions"
                  :column-defs="columnDefs2"
                  :row-data="form.ensDeclarationData"
                  :show-side-bar="false"
                  style="width:100%;"
                  @gridReady="params=>{gridApi2=params.api}"
                />
              </div>
            </div>
          </el-form>
        </div>
        <!--运输信息-->
        <div v-show="(isF16F17 && isYitong)" class="section form-column" style="width: 400px;">
          <el-form :disabled="readonly" label-width="120px" label-position="right" style="height:100%">
            <span class="title" :title="$t('SeaExport.TransportationInformation')">{{ getItemTitle('Shipping Information') }}</span>
            <el-form-item v-show="!isF17" label="ENS NO" :title="$t('SeaExport.EnsNo')" class="blue-text">
              <el-input v-model="form.hblNbr2" no="42" @input="hblNbr2Change" />
            </el-form-item>
            <el-form-item :label="getItemTitle('MB/L NO')" :title="$t('SeaExport.MBLNumber')" :class="isDifferent(true, true,true)">
              <el-input v-model="form.mbl" no="43" @change="mblChange" />
            </el-form-item>
          </el-form>
        </div>
        <!--承运人信息-->
        <div v-show="isYitong" class="section form-column" style="width: 400px;">
          <span class="title" :title="$t('SeaExport.Other')">{{ getItemTitle('Other') }}</span>
          <el-form :disabled="readonly" label-position="right" label-width="110px" style="height:100%">
            <!--承运人信息-->
            <el-form-item :label="getItemTitle('Declarant')">
              <el-button
                :disabled="readonly"
                no="14"
                type="primary"
                style="vertical-align: top"
                @click="copyAddress('Carrier')"
              >{{ $t('SeaExport.CopyConsignor') }}
              </el-button>
              <el-button
                no="2"
                type="primary"
                style="vertical-align: top"
                @click="billAddressDialog.visible=true"
              >{{ $t('SeaExport.CodeSearching') }}
              </el-button>
            </el-form-item>
            <el-form-item :label="getItemTitle('Name')" :title="$t('SeaExport.Name')">
              <el-input v-model="addressForm.carrierName" no="56" @dblclick.native="showSenderAndReceiverDialog('carrier',2)" />
            </el-form-item>
            <el-form-item :label="getItemTitle('Address') + '1'" :title="$t('SeaExport.Addr') + '1'">
              <el-input v-model="addressForm.carrierAddress1" no="57" />
            </el-form-item>
            <el-form-item :label="getItemTitle('Address') + '2'" :title="$t('SeaExport.Addr') + '2'">
              <el-input v-model="addressForm.carrierAddress2" no="58" />
            </el-form-item>
            <el-form-item :label="getItemTitle('Street No')">
              <el-input v-model="addressForm.carrierStreetNo" no="59" />
            </el-form-item>
            <el-form-item :label="getItemTitle('Country')" :title="$t('SeaExport.Country')">
              <div style="display: flex">
                <cargo-advance-select
                  no="60"
                  :select-type="TYPE_NAMES.basic_data_Country"
                  :cache="false"
                  filterable
                  :default-value="addressForm.carrierCountry"
                  :filter-tag-names="['code','chineseName','name']"
                  tag-name="code"
                  tag-value="code"
                  @parentCallBack="p=>{addressForm.carrierCountry = p.value}"
                />
                <span class="center-label" :title="$t('SeaExport.City')">{{ getItemTitle('City') }}</span>
                <el-input v-model="addressForm.carrierCity" no="61" />
              </div>
            </el-form-item>
            <el-form-item :label="getItemTitle('ZIP')" :title="$t('SeaExport.ZIP')">
              <div style="display: flex">
                <el-input v-model="addressForm.carrierPostalcode" no="62" />
                <span style="margin-left: 5px;margin-right: 5px;width: 110px;" :title="$t('SeaExport.Province')">{{ getItemTitle('State') }}</span>
                <el-input v-model="addressForm.carrierProvince" no="63" />
              </div>
            </el-form-item>
            <el-form-item :label="getItemTitle('Email')" :title="$t('SeaExport.Email')">
              <div style="display: flex">
                <el-input v-model="addressForm.carrierEmail" no="64" />
                <span style="margin-left: 5px;margin-right: 5px;width: 110px;" :title="$t('SeaExport.Tel')">{{ getItemTitle('Tel') }}</span>
                <el-input v-model="addressForm.carrierTel" :placeholder="!readonly&&isEFreight?$t('SeaExport.TelSeparate'):''" no="65" />
              </div>
            </el-form-item>
          </el-form>
          <div style="margin-bottom: 10px;" />
        </div>
      </div>
      <!-- 货物信息 -->
      <div v-show="!(isF16F17 && isYitong)" class="section">
        <span class="title" :title="$t('SeaExport.CargoInfo')">{{ getItemTitle('Cargo Information') }}</span>
        <div style="display:flex;flex-direction:column">
          <div v-show="isEdit" style="padding:5px 0">
            <el-button type="primary" :title="$t('SeaExport.AddContainerInformation')" no="69" @click="addCargoInfo">{{ getItemTitle('Add') }}</el-button>
            <el-button type="primary" :title="$t('SeaExport.RemoveContainerInformation')" no="70" @click="deleteCargoInfo">{{ getItemTitle('Delete') }}</el-button>
          </div>
          <cargo-ag-grid
            config-module="131702"
            :grid-options="cargoInfomation.gridOptions"
            :column-defs="cargoInformationColumnDefs"
            :row-data="form.ensCargoInfo"
            style="width:100%;height:350px"
            @gridReady="params=>{gridApi3=params.api}"
          />
        </div>
      </div>
      <!-- 箱子信息 -->
      <div v-show="!(isF16F17 && isYitong)" class="section">
        <span class="title" :title="$t('SeaExport.ContainerInformation')">{{ getItemTitle('House Container Information') }}</span>
        <div style="display:flex;flex-direction:column">
          <div v-show="isEdit" style="padding:5px 0">
            <el-button type="primary" :title="$t('SeaExport.AddContainerInformation')" no="71" @click="cargoDocUsageSelectedDialog.visible=true">{{ getItemTitle('Add') }}</el-button>
            <el-button type="primary" :title="$t('SeaExport.RemoveContainerInformation')" no="72" @click="removeContainerUsageClickHandler">{{ getItemTitle('Delete') }}</el-button>
          </div>
          <cargo-ag-grid
            config-module="131701"
            :grid-options="container.gridOptions"
            :column-defs="containerColumnDefs"
            :row-data="containerFinalRowData"
            style="width:100%;height:350px"
            @gridReady="params=>{container.gridApi=params.api}"
          />
        </div>
      </div>
    </div>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :text-chars="0"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :warning-count="advanceTextDialog.warningCount"
        :disabled="readonly"
        style="height: 198px;"
        no="73"
      />
      <span slot="footer">
        <el-button v-show="isEdit" type="primary" no="74" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="75"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 回执信息弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="receiptInfoDialog.visible"
      :title="receiptInfoDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-ag-grid
        :grid-options="receiptInfoDialog.gridOptions"
        :column-defs="receiptInfoDialog.columnDefs"
        :row-data="receiptInfoDialog.rowData"
        style="height:350px"
        @gridReady="params=>{receiptInfoDialog.gridApi=params.api}"
      />
    </el-dialog>
    <!-- 选择装箱信息弹窗 -->
    <cargo-doc-usage-selected-dialog
      :visible.sync="cargoDocUsageSelectedDialog.visible"
      :job="job"
      :doc-type="CargoDocConsts.AMS"
      @callback="cargoDocUsageSelectedDialog.callback"
    />
    <!-- AMS日志弹窗 -->
    <ams-log-view-title-dialog
      :visible.sync="amsLogViewTitleDialog.visible"
      :row-data="amsLogViewTitleDialog.rowData"
    />
    <!-- 单号抄录弹窗 -->
    <afr-address-dialog
      :visible.sync="searchBillNoDialog.visible"
      :params="searchBillNoDialog.params"
      :no-label="amsTitle"
      :no-title="amsTitleCn"
      @selected="p=>{pm.selectionItemHandler(p)}"
    />
    <!--校验弹框提示-->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="checkDialog.visible"
      :title="checkDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-ag-grid
        :grid-options="checkDialog.gridOptions"
        :column-defs="checkDialog.columnDefs"
        :row-data="checkDialog.rowData"
        :show-side-bar="false"
        style="height:350px"
        @gridReady="params=>{checkDialog.gridApi=params.api}"
      />
    </el-dialog>
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :job="job"
      @callback="codeSearchCallback"
    />
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'
import BillAddressDialog from '@/components/Cargo/Job/billAddressDialog'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import cargoDocUsageSelectedDialog from '@/components/Cargo/Job/cargoDocUsageSelectedDialog'
import amsLogViewTitleDialog from '@/components/Cargo/Job/amsLogViewTitleDialog'
import searchBillNoDialog from '@/views/cargo/v0/SeaExport/components/edi/searchBillNoDialog'
import selectSubLocDialog from '@/views/cargo/v0/SeaExport/components/booking/selectSubLocDialog'
import moment from 'moment'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import EnsAddressFormatForm from '@/views/cargo/v0/SeaExport/components/booking/ams/form/ensAddressFormatForm'
import AfrAddressDialog from '@/components/Cargo/Job/afrAddressDialog'
import StrUtils from '@/utils/StrUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { formatNumberToThousands, isIntegerNumber } from '@/utils'
import AgGridColumnEdit from '@/components/Cargo/grid/agGridColumnEdit'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import UIDUtil from '@/utils/uidUtil'

export default {
  name: 'EnsInfo',
  components: {
    AfrAddressDialog,
    EnsAddressFormatForm,
    CargoRichTextarea, AutoNumberInput,
    cargoAdvanceSelect, cargoInput, cargoPackingSelect, cargoDocUsageSelectedDialog, selectSubLocDialog,
    amsLogViewTitleDialog, searchBillNoDialog, BillAddressDialog
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    tabName: {
      type: String,
      required: true
    },
    ams2: { type: Object, default: () => {} },
    container: { type: Object, default: () => {} },
    form: { type: Object, default: () => {} },
    pm: { type: Object, default: () => {} },
    localData: { type: Object, default: () => {} },
    showCodeSearch: { type: Boolean, default: false },
    showSecondNotifyParty: { type: Boolean, default: false },
    cooperateEdit: { type: Boolean, default: true } // 能否修改
  },
  data() {
    return {
      SystemConstants,
      URL,
      visible: false, // 先隐藏，避免组件在初始化完成前，做一些无效的处理（频繁刷新组件、调用接口等）
      moment,
      TYPE_NAMES,
      CargoDocConsts,
      CargoDocUtil,
      isUppercase: false,
      command1: 'Copy Last Time',
      consignmentTypes: ['FCL', 'LCL'],
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        warningCount: 1000,
        showContact: false,
        extendData: {
          contact: '',
          mobile: '',
          fax: '',
          email: '',
          zipCode: '',
          city: ''
        },
        successCallback: null,
        isUppercase: false,
        formatObj: {
          maxChar: 45
        }
      },
      receiptInfoDialog: {
        visible: false,
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.receiptDate'),
            colId: 'receiptDate',
            field: 'receiptDate',
            width: 100
          },
          {
            headerName: this.$t('SeaExport.receiptCode'),
            colId: 'receiptCode',
            field: 'receiptCode',
            width: 100
          },
          {
            headerName: this.$t('SeaExport.Content'),
            colId: 'receiptContent',
            field: 'receiptContent',
            width: 100
          }
        ],
        rowData: [],
        gridApi: null
      },
      checkDialog: {
        visible: false,
        title: this.$t('SeaExport.VerificationPrompt'),
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.Field'),
            field: 'field',
            width: 250
          },
          {
            headerName: this.$t('SeaExport.ErrorDescription'),
            field: 'errorDescription',
            width: 325
          }
        ],
        rowData: [],
        gridApi: null
      },
      cargoDocUsageSelectedDialog: {
        visible: false,
        callback: rows => {
          this.pm.usageSelectCallBackFunc(rows)
        }
      },
      amsLogViewTitleDialog: {
        visible: false,
        rowData: []
      },
      billAddressDialog: {
        visible: false
      },
      searchBillNoDialog: {
        visible: false,
        params: {}
      },
      curAms: null,
      isEFreight: false,
      isOther: false,
      isYitong: false,
      isTradetech: false,
      isChineseLanguage: false,
      lineType: '', // 区分是Name 还是 Address
      routeCountry: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          singleClickEdit: true,
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor
          },
          defaultColDef: {
            menuTabs: [], // 去掉每列的菜单
            filter: false
          },
          onRowClicked: this.onCarrierGridRowClickedEvent
        },
        rowData: []
      },
      coloadInSelfFilingIndicator: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          singleClickEdit: true,
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridSelectEditor,
            CargoAgGridCommonTextareaEditor
          },
          defaultColDef: {
            menuTabs: [], // 去掉每列的菜单
            filter: false
          },
          onRowClicked: this.onCarrierGridRowClickedEvent2
        },
        rowData: []
      },
      cargoInfomation: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          rowHeight: 32,
          onRowDataChanged: event => {
            // 清除单选行
            event.api.clearFocusedCell()
          },
          singleClickEdit: true,
          frameworkComponents: {
            CargoAgGridSelectEditor,
            CargoAgGridCommonTextareaEditor,
            AgGridColumnEdit,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonInputEditor
          },
          onRowClicked: this.onCarrierGridRowClickedEvent3
        }
      },
      clickedRow: null,
      clickedRow2: null,
      clickedRow3: null,
      gridApi: null,
      gridApi2: null,
      gridApi3: null
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return !this.isEdit
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look' && (!this.form.uuid || this.form.state < 2)
    },
    config() {
      return this.context.config
    },
    job() {
      return this.pm.job
    },
    excelImportDisabled() {
      return this.job.jobState !== 0
    },
    user() {
      return this.context.user || {}
    },
    amsTitle() {
      return this.pm.getNoTitle(false, this.tabName)
    },
    amsTitleCn() {
      return this.pm.getNoTitle(true, this.tabName)
    },
    warningCount() {
      return this.isTradetech ? 40 : 70
    },
    voyageMaxLength() {
      if (this.isTradetech) {
        return 10
      } else if (this.isYitong) {
        return 17
      } else if (this.isEFreight) {
        return 5
      }
      return -1
    },
    imoMaxLength() {
      if (this.isTradetech) {
        return 7
      } else if (this.isYitong) {
        return 35
      } else if (this.isEFreight) {
        return 7
      }
      return -1
    },
    mblMaxLength() {
      if (this.isTradetech) {
        return 25
      } else if (this.isYitong) {
        return 70
      } else if (this.isEFreight) {
        return 35
      }
      return -1
    },
    ensNoMaxLength() {
      if (this.isTradetech) {
        return 18
      } else if (this.isYitong) {
        return 70
      } else if (this.isEFreight) {
        return 35
      }
      return -1
    },
    contactNameMaxLength() {
      if (this.isTradetech) {
        return 25
      } else if (this.isEFreight) {
        return 30
      } else {
        return -1
      }
    },
    containerColumnDefs() {
      const columnDefs = [
        {
          headerName: '',
          colId: 'uuid',
          field: '',
          width: 40,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.getItemTitle('Container Owner'),
          colId: 'containerOwnershipCode',
          field: 'containerOwnershipCode',
          cellEditor: 'CargoAgGridSelectEditor',
          editable: this.isEdit,
          cellEditorParams: {
            selectProps: {
              filterable: true
            },
            options: SystemConstants.EF_ENS_CONTAINER_OWNER,
            tagName: 'chineseName',
            tagValue: 'code'
          },
          valueFormatter: params => {
            return CommonState.getNameByCode(SystemConstants.EF_ENS_CONTAINER_OWNER, params.value)
          }
        },
        {
          headerName: this.getItemTitle('Container No'),
          headerTooltip: this.$t('SeaExport.ContainerNumber'),
          colId: 'containerNo',
          field: 'containerNo',
          width: 160
        },
        {
          headerName: this.getItemTitle('Linked Cargo Information No'),
          colId: 'linkedCargoInformationNo',
          field: 'linkedCargoInformationNo',
          width: 120,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonTextareaEditor'
        }, {
          headerName: this.getItemTitle('Seal No'),
          colId: 'sealNo',
          field: 'sealNo',
          width: 120,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: false,
            inputProps: {
              maxLength: this.isTradetech ? 15 : -1
            }
          }
        }
      ]
      const trColumnDefs = [
        {
          headerName: this.getItemTitle('Description'),
          headerTooltip: this.$t('SeaExport.CommodityName'),
          colId: 'cargoName',
          field: 'cargoName',
          width: 120,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonTextareaEditor'
        },
        {
          headerName: this.getItemTitle('Marks'),
          headerTooltip: this.$t('SeaExport.ShippingMark'),
          colId: 'mark',
          field: 'mark',
          width: 100,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonTextareaEditor'
        }
      ]
      const efColumnDefs = [
        {
          headerName: this.getItemTitle('Container Type'),
          headerTooltip: this.$t('SeaExport.BoxSpecies'),
          colId: 'eqCode',
          field: 'eqCode',
          width: 160,
          cellEditor: 'CargoAgGridSelectEditor',
          editable: this.isEdit,
          cellEditorParams: {
            selectProps: {
              filterable: true
            },
            options: SystemConstants.EF_ENS_CONTAINER_SIZE,
            tagName: 'chineseName',
            tagValue: 'code'
          },
          valueFormatter: params => {
            return CommonState.getNameByCode(SystemConstants.EF_ENS_CONTAINER_SIZE, params.value)
          }
        }
      ]
      const containerType = [
        {
          headerName: this.getItemTitle('Container Type'),
          headerTooltip: this.$t('SeaExport.BoxSpecies'),
          colId: 'eqType',
          field: 'eqType',
          width: 160,
          cellStyle: (params) => {
            return this.setCellColor(params.data, params.colDef.field)
          }
        },
        {
          headerName: this.getItemTitle('Container Size'),
          headerTooltip: this.$t('SeaExport.BoxModel'),
          colId: 'eqSize',
          field: 'eqSize',
          width: 160,
          cellRenderer: (params) => {
            return params.value + '\''
          },
          cellStyle: (params) => {
            return this.setCellColor(params.data, params.colDef.field)
          }
        }
      ]
      if (this.isTradetech) {
        return [...columnDefs, ...containerType, ...trColumnDefs]
      }
      if (this.isEFreight || this.isOther) {
        return [...columnDefs, ...efColumnDefs]
      }
      if (this.isYitong) {
        return [...columnDefs, ...containerType]
      }
      return columnDefs
    },
    declaringCountrys() {
      const countryList = getCacheListByKey(TYPE_NAMES.basic_data_Country)
      if (this.isYitong) {
        return this.localData.ytCountry
      } else {
        return countryList
      }
    },
    isF14() {
      return this.form.declarationType === 'F14'
    },
    isF16F17() {
      return this.form.declarationType === 'F16' || this.form.declarationType === 'F17'
    },
    isF17() {
      return this.form.declarationType === 'F17'
    },
    containerFinalRowData() {
      return this.container.rowData.filter(p => !p.deleted)
    },
    ams2ColumnDefs() {
      return [
        {
          headerName: 'ENS NO',
          headerTooltip: this.$t('SeaExport.EnsNo'),
          colId: 'hblNbr2',
          field: 'hblNbr2',
          flex: 1,
          width: 260
        }, {
          headerName: this.getItemTitle('Send State'),
          headerTooltip: this.$t('SeaExport.SendingStatus'),
          colId: 'ENSSTATUS',
          field: 'ENSSTATUS',
          flex: 1,
          width: 260,
          cellRenderer: params => {
            return this.pm.setStatus(params.value)
          },
          tooltipValueGetter: (params) => {
            return this.pm.setStatus(params.value, true)
          }
        },
        {
          headerName: this.getItemTitle('Receipt Status'),
          headerTooltip: this.$t('SeaExport.ReceiptStatus'),
          hide: this.isTradetech,
          suppressColumnsToolPanel: this.isTradetech,
          colId: 'ensReceiptStatus',
          field: 'ensReceiptStatus',
          flex: 1,
          width: 260,
          cellRenderer: params => {
            if (this.isYitong) {
              return this.pm.setYtEnsReceiptStatus(params.value)
            }
            if (this.isEFreight) {
              return this.pm.setEfEnsReceiptStatus(params.value)
            }
            if (StrUtils.isEmpty(params.value)) {
              return ''
            }
            return params.value
          }
        },
        {
          headerName: this.getItemTitle('Receipt Status'),
          headerTooltip: this.$t('SeaExport.ReceiptStatus'),
          hide: !this.isTradetech,
          suppressColumnsToolPanel: !this.isTradetech,
          colId: 'tradetechEnsReceiptStatus',
          field: 'tradetechEnsReceiptStatus',
          flex: 1,
          width: 260,
          cellRenderer: params => {
            if (StrUtils.isEmpty(params.value)) {
              return ''
            }
            return params.value
          }
        }
      ]
    },
    // 是否是危险品
    isDangerousCargo() {
      return this.form.goodsType === 1
    },
    language() {
      return this.$store.getters.language
    },
    columnDefs() {
      return [
        {
          headerName: this.$t('SeaExport.SequenceNumber'),
          sortable: false,
          suppressMenu: true,
          valueGetter: params => {
            return params.node.rowIndex + 1
          }
        },
        {
          headerName: this.$t('SeaExport.Country'),
          width: 280,
          field: 'country',
          editable: !!this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Country,
              tagValue: 'code',
              tagName: 'code',
              style: 'width: 100%',
              methodParams: { active: true },
              filterable: true
            }
          }
        }
      ]
    },
    columnDefs2() {
      return [
        {
          headerName: 'ID',
          sortable: false,
          width: 20,
          suppressMenu: true,
          valueGetter: params => {
            return params.node.rowIndex + 1
          }
        },
        {
          headerName: this.getItemTitle('SupplementaryDeclarant'),
          colId: 'supplementaryDeclarant',
          field: 'supplementaryDeclarant',
          hide: this.isTradetech || this.isYitong,
          suppressColumnsToolPanel: this.isTradetech || this.isYitong,
          width: 95,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonTextareaEditor'
        },
        {
          headerName: (this.isTradetech || this.isYitong) ? this.getItemTitle('SupplementaryDeclarant eori') : this.getItemTitle('Eori'),
          colId: 'eori',
          field: 'eori',
          width: 95,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonTextareaEditor'
        },
        {
          headerName: this.getItemTitle('BlType'),
          hide: this.isTradetech,
          suppressColumnsToolPanel: this.isTradetech,
          colId: 'blType',
          field: 'blType',
          width: 95,
          cellEditor: 'CargoAgGridSelectEditor',
          editable: this.isEdit,
          cellEditorParams: {
            selectProps: {
              filterable: true
            },
            options: SystemConstants.EF_ENS_BL_TYPE,
            tagName: 'englishName',
            tagValue: 'code'
          },
          valueFormatter: params => {
            return CommonState.getNameByCode(SystemConstants.EF_ENS_BL_TYPE, params.value)
          }
        }
      ]
    },
    receiptColumnDefs() {
      return [
        {
          headerName: this.amsTitle,
          field: 'ams',
          width: 200
        },
        {
          headerName: 'Receipt Status',
          field: 'receiptCode',
          width: 200,
          cellRenderer: params => {
            return params.value
          }
        },
        {
          headerName: 'Description',
          field: 'remark',
          width: 375
        },
        {
          headerName: 'Time',
          field: 'receiptDate',
          width: 200
        }
      ]
    },
    cargoInformationColumnDefs() {
      return [{
        headerName: '',
        colId: 'uuid',
        field: '',
        width: 40,
        headerCheckboxSelection: true,
        checkboxSelection: true,
        sortable: false,
        suppressMenu: true,
        suppressSizeToFit: true,
        resizable: false
      }, {
        headerName: this.getItemTitle('Correlative No'), field: 'correlativeNo', colId: 'correlativeNo', minWidth: 140,
        editable: () => this.isEdit,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            precision: 0,
            max: 999999999,
            min: 0,
            controlsPosition: 'right',
            style: 'width: 100%'
          }
        },
        valueFormatter: params => {
          return this.$numeral(params.value).format('0')
        },
        onCellValueChanged: (params) => {
          this.onCellChange(params)
        }
      }, {
        headerName: this.getItemTitle('HS CODE'),
        colId: 'hsCode',
        field: 'hsCode',
        width: 120,
        editable: this.isEdit,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: false,
          inputProps: {
            maxLength: this.isYitong ? 8 : 6
          }
        }
      }, {
        headerName: this.getItemTitle('Quantity'),
        headerTooltip: this.$t('SeaExport.itemCount'),
        colId: 'quantity',
        field: 'quantity',
        width: 160,
        cellRendererFramework: 'agGridColumnEdit',
        custom: {
          isEdit: this.isEdit,
          tag: 'cargo-cell-input',
          attrs: {
            complexTextConverter: (data, val) => {
              return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 0))
            }
          }
        }
      }, {
        headerName: this.getItemTitle('Unit Type'),
        headerTooltip: this.$t('SeaExport.Packing'),
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        colId: 'packing',
        field: 'packing',
        width: 160,
        editable: this.isEdit,
        cellEditorParams: {
          selectProps: {
            selectType: TYPE_NAMES.basic_data_Packing,
            filterable: true,
            tagValue: 'code',
            customLabel: (item) => this.language === 'zh' ? `${item.chineseName}[${item.name}]` : `${item.name}[${item.chineseName}]`,
            showCustomLabelInOption: true
          }
        },
        valueFormatter: params => {
          return ColumnUtils.packingCodeLabelFun(params.value)
        }
      }, {
        headerName: this.getItemTitle('Gross Weight'),
        headerTooltip: this.$t('SeaExport.GrossWeight'),
        colId: 'weight',
        field: 'weight',
        width: 260,
        cellStyle: (params) => {
          return this.setCellColor(params.data, params.colDef.field)
        },
        cellRendererFramework: 'agGridColumnEdit',
        custom: {
          isEdit: this.isEdit,
          tag: 'cargo-cell-input',
          attrs: {
            complexTextConverter: (data, val) => {
              return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, this.isTradetech ? 2 : 3))
            }
          }
        }
      }, {
        headerName: this.getItemTitle('Volume'),
        headerTooltip: this.$t('SeaExport.Cubage'),
        colId: 'cubage',
        field: 'cubage',
        width: 260,
        cellStyle: (params) => {
          return this.setCellColor(params.data, params.colDef.field)
        },
        cellRendererFramework: 'agGridColumnEdit',
        custom: {
          isEdit: this.isEdit,
          tag: 'cargo-cell-input',
          attrs: {
            complexTextConverter: (data, val) => {
              return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
            }
          }
        }
      }, {
        headerName: this.getItemTitle('Description'),
        colId: 'cargoEnglishName',
        field: 'cargoEnglishName',
        width: 200,
        editable: this.isEdit,
        cellEditor: 'CargoAgGridCommonTextareaEditor'
      }, {
        headerName: this.getItemTitle('Marks'),
        colId: 'mark',
        field: 'mark',
        width: 200,
        editable: this.isEdit,
        cellEditor: 'CargoAgGridCommonTextareaEditor'
      }, {
        headerName: this.getItemTitle('UN Danger Code'),
        colId: 'undgCode',
        field: 'undgCode',
        width: 200,
        editable: this.isEdit,
        cellEditor: 'CargoAgGridCommonTextareaEditor'
      }, {
        headerName: this.getItemTitle('CUS Code'),
        colId: 'cusCode',
        field: 'cusCode',
        width: 200,
        editable: this.isEdit,
        cellEditor: 'CargoAgGridCommonTextareaEditor'
      }
      ]
    },
    addressForm() {
      return this.form.afrAddress[0] || {}
    }
  },
  watch: {
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.visible = true
    this.isEFreight = this.config.get('ENSSupplierConfiguration') === 'eFreight'
    this.isYitong = this.config.get('ENSSupplierConfiguration') === 'yitong'
    this.isTradetech = this.config.get('ENSSupplierConfiguration') === 'tradetech'
    this.isOther = this.config.get('ENSSupplierConfiguration') === 'other'
    this.isChineseLanguage = Number(this.config.get('AntiTerrorismShippingAfrLanguageSwitching')) === 1
  },
  methods: {
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    /**
     * 移除装箱信息
     */
    removeContainerUsageClickHandler() {
      const rows = this.container.gridApi.getSelectedRows()
      if (rows.length === 0) {
        return
      }
      for (const row of rows) {
        if (row.uuid) {
          row.deleted = true
        } else {
          const index = this.container.rowData.findIndex(p => p === row)
          if (index >= 0) {
            this.container.rowData.splice(index, 1)
          }
        }
      }
      const tempRowData = this.container.rowData
      this.container.rowData = []
      this.$nextTick(() => {
        this.container.rowData = tempRowData
        if (this.form.docType === CargoDocConsts.AMS) {
          this.pm.refreshEdiGrid()
        }
      })
    },
    commandHandle(command) {
      switch (command) {
        case 'Code Searching':
          this.billAddressDialog.visible = true
          break
        case 'Copy Last Time':
          this.pm.onCopy1()
          break
        case 'Copy By File NO':
          Object.assign(this.searchBillNoDialog.params, {
            docType: 'AMS',
            selectType: 'single',
            job: this.job
          })
          this.searchBillNoDialog.visible = true
          break
      }
    },
    hblNbr2Change() {
      const { gridApi } = this.ams2
      gridApi.refreshCells()
      this.$nextTick(() => {
        if (this.curAms) {
          const { rowsToDisplay } = gridApi.getModel()
          const selectedNode = rowsToDisplay.find(node => node.data.hblNbr2 === this.curAms.hblNbr2)
          selectedNode.setSelected(true)
        }
      })
    },
    mblChange() {
      if (this.isYitong && this.isF17) {
        this.form.hblNbr2 = this.form.mbl
      }
    },
    portChange(p, portCodeField, portNameField) {
      const form = this.form
      form[portCodeField] = p.value
      form[portNameField] = p.englishName
    },
    showSenderAndReceiverDialog(type, count) {
      const value = this.mergeSenderAndReceiverLineForAmsAndManifest(type, count)
      switch (type) {
        case 'shipper':
          this.advanceTextDialog.title = this.$t('SeaExport.Shipper')
          this.advanceTextDialog.warningCount = this.isTradetech ? 40 : 70
          break
        case 'consignee':
          this.advanceTextDialog.title = this.$t('SeaExport.Consignee')
          this.advanceTextDialog.warningCount = this.isTradetech ? 40 : 70
          break
        case 'notify':
          this.advanceTextDialog.title = this.$t('SeaExport.Notifier')
          this.advanceTextDialog.warningCount = this.isTradetech ? 40 : 70
          break
        case 'seller':
          this.advanceTextDialog.title = this.$t('SeaExport.Seller')
          this.advanceTextDialog.warningCount = 40
          break
        case 'buyer':
          this.advanceTextDialog.title = this.$t('SeaExport.Buyer')
          this.advanceTextDialog.warningCount = 40
          break
        case 'shipperEmail':
        case 'consigneeEmail':
        case 'notifyEmail':
          this.advanceTextDialog.title = this.$t('SeaExport.Email')
          if (this.isYitong) {
            this.advanceTextDialog.warningCount = 512
          } else if (this.isEFreight) {
            this.advanceTextDialog.warningCount = 100
          } else if (this.isTradetech) {
            this.advanceTextDialog.warningCount = 50
          }
          break
        case 'shipperTel':
        case 'consigneeTel':
        case 'notifyTel':
          this.advanceTextDialog.title = this.$t('SeaExport.Tel')
          if (this.isYitong) {
            this.advanceTextDialog.warningCount = 512
          } else if (this.isEFreight) {
            this.advanceTextDialog.warningCount = 24
          } else if (this.isTradetech) {
            this.advanceTextDialog.warningCount = 23
          }
          break
      }
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = () => this.splitSenderAndReceiverLineForAmsAndManifest(type, count, this.advanceTextDialog.value)
      this.advanceTextDialog.visible = true
    },
    mergeSenderAndReceiverLineForAmsAndManifest(type, count) {
      const addressForm = this.form.afrAddress[0]
      if (type === 'shipper' || type === 'consignee' || type === 'notify') {
        let result = ''
        for (let i = 1; i < count; ++i) {
          let no = i
          if (i !== 1) {
            no = (i + 1)
          }
          result += addressForm[`${type}Line${no}`] || ''
          result += '\n'
        }
        result += (addressForm[`${type}Line${count + 1}`] || '')
        return result.trimEnd()
      } else if (type === 'seller' || type === 'buyer') {
        const result2 = addressForm[`${type}Name`] + '\n' + addressForm[`${type}Address1`] + '\n' + addressForm[`${type}Address2`]
        return result2.trimEnd()
      } else {
        return addressForm[type].trimEnd()
      }
    },
    splitSenderAndReceiverLineForAmsAndManifest(type, count, val) {
      const addressForm = this.form.afrAddress[0]
      if (type === 'shipper' || type === 'consignee' || type === 'notify') {
        let fromIndex = 0
        let i = 1
        let no = 1
        for (; i < count; ++i) {
          no = (i !== 1) ? (i + 1) : i
          const index = val.indexOf('\n', fromIndex)
          if (index === -1) {
            addressForm[`${type}Line${no}`] = ''
            continue
          }
          addressForm[`${type}Line${no}`] = val.substring(fromIndex, index)
          fromIndex = index + 1
        }
        addressForm[`${type}Line${no + 1}`] = val.substring(fromIndex)
      } else if (type === 'seller' || type === 'buyer') {
        if (val) {
          const datas = val.split('\n')
          addressForm[`${type}Name`] = datas[0]
          if (datas.length === 2) {
            addressForm[`${type}Address1`] = datas[1]
          } else if (datas.length > 2) {
            addressForm[`${type}Address1`] = datas[1]
            addressForm[`${type}Address2`] = datas[2]
          } else {
            addressForm[`${type}Address1`] = ''
          }
        } else {
          addressForm[`${type}Name`] = ''
          addressForm[`${type}Address1`] = ''
          addressForm[`${type}Address2`] = ''
        }
      } else {
        addressForm[type] = val
      }
    },
    isDifferent(eFreight, yitong, tradetech) {
      if (eFreight && (this.isEFreight || this.isOther)) {
        return 'blue-text'
      }
      if (yitong && this.isYitong) {
        return 'blue-text'
      }
      if (tradetech && this.isTradetech) {
        return 'blue-text'
      }
      return ''
    },
    isShow(eFreight, yitong, tradetech) {
      if (eFreight && (this.isEFreight || this.isOther)) {
        return true
      }
      if (yitong && this.isYitong) {
        return true
      }
      if (tradetech && this.isTradetech) {
        return true
      }
      return false
    },
    cityMaxLength(value) {
      if (!value) return ''
      if (this.isYitong) {
        return value.length > 35 ? 'warning' : ''
      } else if (this.isEFreight) {
        return value.length > 25 ? 'warning' : ''
      } else if (this.isTradetech) {
        return value.length > 26 ? 'warning' : ''
      } else {
        return ''
      }
    },
    stateMaxLength(value) {
      if (!value) return ''
      if (this.isEFreight || this.isTradetech) {
        return value.length > 2 ? 'warning' : ''
      } else {
        return ''
      }
    },
    zipMaxLength(value) {
      if (!value) return ''
      if (this.isYitong) {
        return value.length > 17 ? 'warning' : ''
      } else if (this.isEFreight) {
        return value.length > 10 ? 'warning' : ''
      } else if (this.isTradetech) {
        return value.length > 10 ? 'warning' : ''
      } else {
        return ''
      }
    },
    emailMaxLength(value) {
      if (!value) return ''
      if (this.isYitong) {
        return value.length > 512 ? 'warning' : ''
      } else if (this.isEFreight) {
        return value.length > 100 ? 'warning' : ''
      } else if (this.isTradetech) {
        return value.length > 50 ? 'warning' : ''
      } else {
        return ''
      }
    },
    telMaxLength(value) {
      if (!value) return ''
      if (this.isYitong) {
        return value.length > 512 ? 'warning' : ''
      } else if (this.isEFreight) {
        return value.length > 24 ? 'warning' : ''
      } else if (this.isTradetech) {
        return value.length > 23 ? 'warning' : ''
      } else {
        return ''
      }
    },
    setCellColor(data, field) {
      const importDifferentField = this.localData.importDifferentField
      if (!importDifferentField ||
        !importDifferentField.container ||
        !importDifferentField.container[data.containerNo]) {
        return {}
      }
      if (importDifferentField.container[data.containerNo].hasOwnProperty(field)) {
        return { 'color': 'red' }
      }
      return {}
    },
    selectSubLocCallBack(row, type) {
      if (type === 1) {
        if (row) {
          this.form.dishSubLoc = row.subLocationCode
          this.localData.dishSubLocStr = row.subLocationCode + '-' + row.aciPortCode + '-' + row.inlandLocation
        } else {
          this.form.dishSubLoc = ''
          this.localData.dishSubLocStr = ''
        }
      } else if (type === 2) {
        if (row) {
          this.form.subLocationCode = row.subLocationCode
          this.localData.subLocationCodeStr = row.subLocationCode + '-' + row.aciPortCode + '-' + row.inlandLocation
        } else {
          this.form.subLocationCode = ''
          this.localData.subLocationCodeStr = ''
        }
      }
      this.selectSubLocDialog.visible = false
    },
    changeVoyage() {
      this.form.voyageFlight = CargoDocUtil.replaceVoyage(this.form.voyageFlight, true)
    },
    voyageFlightBlur() {
      if (this.isTradetech && this.form.voyageFlight) {
        this.form.voyageFlight = this.form.voyageFlight.replace(/[^a-zA-Z0-9]/g, '')
      }
    },
    openCheckTip(data) {
      this.checkDialog.visible = true
      // 去重
      const uniqueMap = new Map()
      if (data) {
        data.forEach(item => {
          let key = item.field + '|' + item.errorDescription
          if (item.type) {
            key = item.type + item.field + '|' + item.errorDescription
          }
          if (!uniqueMap.has(key)) {
            if (item.type) {
              item.field = this.getItemTitle(item.type) + ' ' + this.getItemTitle(item.field)
            } else {
              item.field = this.getItemTitle(item.field)
            }
            uniqueMap.set(key, item)
          }
        })
      }
      this.checkDialog.rowData = Array.from(uniqueMap.values())
    },
    getItemTitle(targetCode) {
      if (this.isChineseLanguage) {
        return ColumnUtils.afrLabelFunc(targetCode)
      }
      return targetCode
    },
    onCarrierGridRowClickedEvent(e) {
      this.clickedRow = e.data
    },
    onCarrierGridRowClickedEvent2(e) {
      this.clickedRow2 = e.data
    },
    onCarrierGridRowClickedEvent3(e) {
      this.clickedRow3 = e.data
    },
    addRouteCountry() {
      if (!this.form.routeCountryList) {
        this.form.routeCountryList = []
      }
      this.form.routeCountryList.push({
        country: ''
      })
      this.gridApi.setRowData(this.form.routeCountryList)
    },
    addRouteCountry2() {
      if (!this.form.ensDeclarationData) {
        this.form.ensDeclarationData = []
      } else if ((this.isYitong || this.isTradetech) && this.form.ensDeclarationData.length === 1) {
        this.$message.warning(this.$t('SeaExport.NeedOne'))
        return
      }
      if (this.isYitong) {
        this.form.ensDeclarationData.push({
          supplementaryDeclarant: '', eori: '', blType: '2'
        })
      } else {
        this.form.ensDeclarationData.push({
          supplementaryDeclarant: '', eori: '', blType: ''
        })
      }
      this.gridApi2.setRowData(this.form.ensDeclarationData)
    },
    addCargoInfo() {
      let correlativeNo = 0
      if (!this.form.ensCargoInfo) {
        this.form.ensCargoInfo = []
        correlativeNo = 1
      } else {
        for (const item of this.form.ensCargoInfo) {
          if (item.correlativeNo && isIntegerNumber(item.correlativeNo) && Number(item.correlativeNo) > Number(correlativeNo)) {
            correlativeNo = item.correlativeNo
          }
        }
        correlativeNo = Number(correlativeNo) + 1
      }
      this.form.ensCargoInfo.push({
        weight: 0,
        cubage: 0,
        quantity: 0,
        deleted: false,
        correlativeNo: correlativeNo,
        newUuid: UIDUtil.createUID()
      })
      this.gridApi3.setRowData(this.form.ensCargoInfo)
    },
    deleteRouteCountry() {
      const index = this.form.routeCountryList.indexOf(this.clickedRow)
      if (index !== -1) {
        this.form.routeCountryList.splice(index, 1)
      }
      this.gridApi.setRowData(this.form.routeCountryList)
    },
    deleteRouteCountry2() {
      const index = this.form.ensDeclarationData.indexOf(this.clickedRow2)
      if (index !== -1) {
        this.form.ensDeclarationData.splice(index, 1)
        if (this.clickedRow2.uuid) {
          if (!this.form.delEnsDeclarationUuids) {
            this.form.delEnsDeclarationUuids = []
          }
          this.form.delEnsDeclarationUuids.push(this.clickedRow2.uuid)
        }
      }
      this.gridApi2.setRowData(this.form.ensDeclarationData)
    },
    deleteCargoInfo() {
      const rows = this.gridApi3.getSelectedRows()
      if (rows.length === 0) {
        return
      }
      for (const row of rows) {
        const index = this.form.ensCargoInfo.findIndex(p => p.uuid === row.uuid)
        if (index >= 0) {
          this.form.ensCargoInfo.splice(index, 1)
        } else {
          const index = this.form.ensCargoInfo.findIndex(p => p.newUuid === row.newUuid)
          if (index >= 0) {
            this.form.ensCargoInfo.splice(index, 1)
          }
        }
        if (row.uuid) {
          if (!this.form.delEnsCargoInfoUuids) {
            this.form.delEnsCargoInfoUuids = []
          }
          this.form.delEnsCargoInfoUuids.push(row.uuid)
        }
      }
      this.gridApi3.setRowData(this.form.ensCargoInfo)
    },
    deleteAllCargoInfo() {
      if (this.form.ensCargoInfo && this.form.ensCargoInfo.length > 0) {
        for (const row of this.form.ensCargoInfo) {
          if (row.uuid) {
            if (!this.form.delEnsCargoInfoUuids) {
              this.form.delEnsCargoInfoUuids = []
            }
            this.form.delEnsCargoInfoUuids.push(row.uuid)
          }
        }
      }
    },
    refreshList() {
      if (this.form.routeCountryList) {
        setTimeout(() => {
          this.gridApi.setRowData(this.form.routeCountryList)
        }, 100)
      }
      if (this.form.ensDeclarationData) {
        setTimeout(() => {
          this.gridApi2.setRowData(this.form.ensDeclarationData)
        }, 100)
      }
      if (this.form.ensCargoInfo) {
        setTimeout(() => {
          this.gridApi3.setRowData(this.form.ensCargoInfo)
        }, 100)
      }
    },
    copyAddress(name) {
      if (name === 'Seller') {
        this.addressForm.sellerName = this.addressForm.shipperLine1
        this.addressForm.sellerAddress1 = this.addressForm.shipperLine3
        this.addressForm.sellerAddress2 = this.addressForm.shipperLine4
        this.addressForm.sellerStreetNo = this.addressForm.shipperStreetNo
        this.addressForm.sellerCountry = this.addressForm.shipperCountry
        this.addressForm.sellerCity = this.addressForm.shipperCity
        this.addressForm.sellerPostalcode = this.addressForm.shipperPostalcode
        this.addressForm.sellerProvince = this.addressForm.shipperProvince
        this.addressForm.sellerEmail = this.addressForm.shipperEmail
        this.addressForm.sellerTel = this.addressForm.shipperTel
        this.addressForm.sellerContactName = this.addressForm.shipperContactName
        this.addressForm.sellerTypeOfPerson = this.addressForm.shipperTypeOfPerson
        this.addressForm.sellerEori = this.addressForm.shipperEori
      } else if (name === 'Buyer') {
        this.addressForm.buyerName = this.addressForm.consigneeLine1
        this.addressForm.buyerAddress1 = this.addressForm.consigneeLine3
        this.addressForm.buyerAddress2 = this.addressForm.consigneeLine4
        this.addressForm.buyerStreetNo = this.addressForm.consigneeStreetNo
        this.addressForm.buyerCountry = this.addressForm.consigneeCountry
        this.addressForm.buyerCity = this.addressForm.consigneeCity
        this.addressForm.buyerPostalcode = this.addressForm.consigneePostalcode
        this.addressForm.buyerProvince = this.addressForm.consigneeProvince
        this.addressForm.buyerEmail = this.addressForm.consigneeEmail
        this.addressForm.buyerTel = this.addressForm.consigneeTel
        this.addressForm.buyerContactName = this.addressForm.consigneeContactName
        this.addressForm.buyerTypeOfPerson = this.addressForm.consigneeTypeOfPerson
        this.addressForm.buyerEori = this.addressForm.consigneeEori
      } else if (name === 'Carrier') {
        this.addressForm.carrierName = this.addressForm.shipperLine1
        this.addressForm.carrierAddress1 = this.addressForm.shipperLine3
        this.addressForm.carrierAddress2 = this.addressForm.shipperLine4
        this.addressForm.carrierStreetNo = this.addressForm.shipperStreetNo
        this.addressForm.carrierCountry = this.addressForm.shipperCountry
        this.addressForm.carrierCity = this.addressForm.shipperCity
        this.addressForm.carrierPostalcode = this.addressForm.shipperPostalcode
        this.addressForm.carrierProvince = this.addressForm.shipperProvince
        this.addressForm.carrierEmail = this.addressForm.shipperEmail
        this.addressForm.carrierTel = this.addressForm.shipperTel
      }
    },

    codeSearchCallback(data) {
      if (data.shipperInfo) {
        const parts = data.shipperInfo.split('\n')
        this.addressForm.carrierName = parts[0]
        this.addressForm.carrierAddress1 = parts[1]
        this.addressForm.carrierAddress2 = parts[2]
      }
    },
    // 验证地址变红
    lengthOverAddr(value) {
      if (!value) return ''
      if (this.isTradetech) {
        return value.length > 40 ? 'warning' : ''
      } else {
        return ''
      }
    },
    onCellChange(params) {
      let i = 0
      if (this.form.ensCargoInfo) {
        for (const row of this.form.ensCargoInfo) {
          if (row.correlativeNo === params.data.correlativeNo) {
            i++
          }
        }
        if (i > 1) {
          this.$message.error(this.$t('SeaExport.NonRepeatingNumbers'))
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .ams-info{
    .warning .el-input__inner{
      color: red !important;
    }
    .warning{
      color: red !important;
    }
    .el-radio__label{
      font-size: 12px;
      font-weight: normal;
      color: #333333 !important;
    }
    .el-checkbox__label{
      font-weight: normal;
      color: #333333 !important;
    }
  }
  .custom-label {
    width: 300px !important; /* 设置 label 的固定宽度 */
  }
  .blue-text{
    color: #1f75d5 !important;
  }
  .address-format-from{
    .center-label{
      margin-left: 5px;
      margin-right: 5px;
      width: 110px;
    }
  }
</style>
